// extracted by mini-css-extract-plugin
export var socialButton = "social-button-module--social-button--rF+Ge";